<template>
  <div class="table" v-loading="loading">
    <vxe-toolbar ref="xToolbar" custom print export>
      <template #buttons>
        <span>{{ $t("message.title.totalResults") + totalLength + $t("message.title.resultsNums") }}</span>
      </template>
    </vxe-toolbar>
    <vxe-table border height="500" show-overflow align="center" class="mytable-style" resizable ref="table"
      :print-config="{}" :toolbar-config="tableToolbar" :row-style="rowStyle" :data="gridOptions.data">
      <vxe-column type="seq" width="60" title=" "></vxe-column>
      <vxe-column v-for="item in abcList" :title="item.title" :field="item.field" :key="item.index"
        :minWidth="item.minWidth"></vxe-column>
    </vxe-table>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      abcList: [],
      loading: false,
      totalLength: 0,
      tableToolbar: {
        // buttons: [{ code: "myInsert", name: "aaaaaaaaaaaaa", type: "text" }],
        print: true,
        export: true,
        zoom: true,
        custom: true,
        slots: {
          tools: "tools",
        },
      },
      rowStyle: { cursor: "pointer" },
      gridOptions: {
        id: '',
        border: true,
        resizable: true,
        showOverflow: true,
        stripe: true,
        height: 660,
        align: "left",
        highlightHoverRow: true,
        editConfig: { trigger: "dblclick", mode: "row" },
        columns: [],
        data: [],
        customConfig: { storage: true }
      },
    }
  },
  methods: {

    xx(obj) {
      const column = obj.columnInfo;
      // let list = []
      this.abcList = column.ids.map((i, e) => { return { 'field': "a" + i, "title": column.names[e] } });
      // this.abcList.unshift({'field': , })
      this.totalLength = obj.totalRecords;

      // let list = this.abcList.map(i =>({i[]}))
      this.gridOptions.data = obj.rows.map(i => {
        // const arr = column.ids.map((j,e) => ({[j]:i.cells[e].val || ''}));
        let item = {};
        for (let j = 0; j < column.ids.length; j++) {
          const e = "a" + column.ids[j];
          item[e] = i.cells[j].val || ''
        }
        return item;
      })
      console.log(this.gridOptions.data);
      this.loading = false;
    },


    getData() {
      this.loading = true;
      axios.get('/ppm/projectStatus/buildProjectDetailReport').then(res => {
        this.xx(res.data.object.result)
      })
    },
  },
  created() {
    this.getData()
  }

}
</script>

<style>
.table {
  padding: 25px;
}
</style>